var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUpArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.76571 0.903594L0.90571 2.76359C0.692377 2.97026 0.839044 3.33026 1.13904 3.33026H2.33238V7.33693C2.33238 7.70359 2.63238 8.00359 2.99904 8.00359C3.36571 8.00359 3.66571 7.70359 3.66571 7.33693V3.33026H4.85904C5.15904 3.33026 5.30571 2.97026 5.09238 2.76359L3.23238 0.903594C3.10571 0.776927 2.89238 0.776927 2.76571 0.903594ZM7.66571 10.0103V6.00359C7.66571 5.63693 7.36571 5.33693 6.99904 5.33693C6.63238 5.33693 6.33238 5.63693 6.33238 6.00359V10.0103H5.13904C4.83904 10.0103 4.69238 10.3703 4.90571 10.5769L6.76571 12.4303C6.89904 12.5569 7.10571 12.5569 7.23904 12.4303L9.09904 10.5769C9.31238 10.3703 9.15904 10.0103 8.86571 10.0103H7.66571Z",
    fill: "#424242"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpArrowDown);
export default __webpack_public_path__ + "static/media/arrow-up-arrow-down.04536c3a56ca6a2dcf1eb9b5bd4417cb.svg";
export { ForwardRef as ReactComponent };